import { createSelector } from 'reselect';
import TeamInfoConstants from '../constants/TeamInfo.constants';
import extractListItems from 'Shared/utils/extractListItems';

const getTeamInfoState = state => state.teamInfo;

export const getTeamInfoLoading = createSelector([getTeamInfoState], teamInfo =>
  teamInfo.get(TeamInfoConstants.State.LOADING)
);

export const getTeamInfoError = createSelector([getTeamInfoState], teamInfo =>
  teamInfo.get(TeamInfoConstants.State.ERROR)
);

export const getTeamInfoByWorkspaceMap = createSelector([getTeamInfoState], teamInfo =>
  teamInfo.get(TeamInfoConstants.State.TEAM_INFO_BY_WORKSPACE_SLUG)
);

export const getTeamInfoByWorkspaceSlug = createSelector(
  [getTeamInfoByWorkspaceMap, (_, props) => props.workspaceSlug],
  (teamInfoMap, workspaceSlug) => {
    if (!workspaceSlug) return null;
    return teamInfoMap?.get(workspaceSlug);
  }
);

export const getTeamType = createSelector([getTeamInfoByWorkspaceSlug], teamInfo => teamInfo?.get('teamType') ?? '');

export const getShortTeamDescription = createSelector([getTeamInfoByWorkspaceSlug], teamInfo => {
  const rawDesc = teamInfo?.get('shortTeamDescription') ?? '';
  return rawDesc.replace(/&nbsp;/g, ' ');
});

export const getTeamConversationTips = createSelector([getTeamInfoByWorkspaceSlug], teamInfo => {
  const rawTips = teamInfo?.get('teamConversationTips') ?? '';
  return extractListItems(rawTips);
});

export const getTeamReminders = createSelector([getTeamInfoByWorkspaceSlug], teamInfo => {
  const rawReminders = teamInfo?.get('teamReminders') ?? '';
  return extractListItems(rawReminders);
});

export const getIndividualContributionInsight = createSelector([getTeamInfoByWorkspaceSlug], teamInfo => {
  const insights = teamInfo?.get('individualContributionInsight')?.toJS() ?? [];
  return insights.map(insight => ({
    surveyUserGuid: insight.surveyUserGuid,
    contributionInsight: insight.contributionInsight ? insight.contributionInsight.replace(/<\/?b>/g, '') : '',
  }));
});
